import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner, Table, Badge } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaEdit, FaArrowLeft, FaLink, FaCheck, FaTimes } from "react-icons/fa";

export default function ModalAssocBandeira({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState('lista'); 
    const [associacoes, setAssociacoes] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeirasSugeridas: [] });
    
    const [filtros, setFiltros] = useState({
        roteamento: '',
        bandeiraimp: '',
        bandflor: ''
    });

    const [form, setForm] = useState({
        roteamento: '',
        bandeiraimp: '',
        bandflor: ''
    });

    useEffect(() => {
        if (show) {
            listarAssociacoes();
            carregarRoteamentos();
            setView('lista');
            setFiltros({ roteamento: '', bandeiraimp: '', bandflor: '' });
        }
    }, [show]);

    const carregarRoteamentos = () => {
        api.get('/financeiro/conciliacao/roteamentos')
            .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
            .catch(err => console.error(err));
    };

    const listarAssociacoes = async () => {
        setLoading(true);
        try {
            const res = await api.get('/financeiro/conciliacao/associacoes');
            setAssociacoes(res.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleEditar = (item) => {
        setForm({
            roteamento: item.ROTEAMENTO || item.roteamento,
            bandeiraimp: item.BANDEIRAIMP || item.bandeiraimp,
            bandflor: item.BANDFLOR || item.bandflor || ''
        });
        api.get(`/financeiro/conciliacao/bandeiras?roteamento=${item.ROTEAMENTO || item.roteamento}`)
            .then(res => setLookups(prev => ({ ...prev, bandeirasSugeridas: res.data })));
        
        setView('formulario');
    };

    const handleSalvar = async () => {
        if (!form.bandflor) {
            Swal.fire("Atenção", "Selecione uma bandeira para associar", "warning");
            return;
        }
        setLoading(true);
        try {
            await api.post('/financeiro/conciliacao/associar', form);
            Swal.fire("Sucesso", "Associação realizada!", "success");
            listarAssociacoes();
            setView('lista');
        } catch (err) {
            Swal.fire("Erro", "Erro ao salvar associação", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFiltroChange = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({ ...prev, [name]: value }));
    };

    const getUniqueValues = (key) => {
        const values = associacoes.map(item => {
            const val = item[key] || item[key.toUpperCase()];
            return val || (key === 'bandflor' ? "Não associada" : "");
        });
        return [...new Set(values)].filter(v => v !== "").sort();
    };

    const dadosFiltrados = associacoes.filter(item => {
        const rot = (item.roteamento || item.ROTEAMENTO || "").toLowerCase();
        const imp = (item.bandeiraimp || item.BANDEIRAIMP || "").toLowerCase();
        const flor = (item.bandflor || item.BANDFLOR || "Não associada").toLowerCase();

        return (
            (filtros.roteamento === "" || rot === filtros.roteamento.toLowerCase()) &&
            (filtros.bandeiraimp === "" || imp === filtros.bandeiraimp.toLowerCase()) &&
            (filtros.bandflor === "" || flor === filtros.bandflor.toLowerCase())
        );
    });

    return (
        <Modal show={show} onHide={onHide} centered size="lg" backdrop="static" scrollable>
            <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2 text-white">
                    <FaLink /> ASSOCIAÇÃO DE BANDEIRAS
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light p-3">
                {view === 'lista' ? (
                    <div className="table-responsive bg-white shadow-sm border rounded-3" style={{ maxHeight: '480px' }}>
                        <Table striped bordered hover size="sm" className="mb-0 align-middle">
                            <thead className="table-dark small sticky-top">
                                <tr>
                                    <th className="py-2 px-2">
                                        <span className="d-block mb-1">Roteamento</span>
                                        <Form.Select 
                                            size="sm" 
                                            name="roteamento"
                                            className="bg-dark text-white border-secondary shadow-none py-0 px-1"
                                            style={{ fontSize: '0.72rem' }}
                                            value={filtros.roteamento}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">(Todos)</option>
                                            {getUniqueValues('roteamento').map((v, i) => <option key={i} value={v}>{v}</option>)}
                                        </Form.Select>
                                    </th>
                                    <th className="py-2 px-2">
                                        <span className="d-block mb-1">Bandeira (Importada)</span>
                                        <Form.Select 
                                            size="sm" 
                                            name="bandeiraimp"
                                            className="bg-dark text-white border-secondary shadow-none py-0 px-1"
                                            style={{ fontSize: '0.72rem' }}
                                            value={filtros.bandeiraimp}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">(Todos)</option>
                                            {getUniqueValues('bandeiraimp').map((v, i) => <option key={i} value={v}>{v}</option>)}
                                        </Form.Select>
                                    </th>
                                    <th className="py-2 px-2">
                                        <span className="d-block mb-1">Associada a (Sistema)</span>
                                        <Form.Select 
                                            size="sm" 
                                            name="bandflor"
                                            className="bg-dark text-white border-secondary shadow-none py-0 px-1"
                                            style={{ fontSize: '0.72rem' }}
                                            value={filtros.bandflor}
                                            onChange={handleFiltroChange}
                                        >
                                            <option value="">(Todos)</option>
                                            {getUniqueValues('bandflor').map((v, i) => <option key={i} value={v}>{v}</option>)}
                                        </Form.Select>
                                    </th>
                                    <th width="60" className="text-center align-middle py-2">Ação</th>
                                </tr>
                            </thead>
                            <tbody className="small">
                                {loading ? (
                                    <tr><td colSpan="4" className="text-center py-4"><Spinner size="sm" animation="border" style={{ color: '#8b0000' }} /></td></tr>
                                ) : dadosFiltrados.map((item, i) => {
                                    const assoc = item.bandflor || item.BANDFLOR;
                                    return (
                                        <tr key={i}>
                                            <td className="px-2 fw-semibold text-secondary">{item.roteamento || item.ROTEAMENTO}</td>
                                            <td className="px-2">{item.bandeiraimp || item.BANDEIRAIMP}</td>
                                            <td className="px-2">
                                                {assoc ? (
                                                    <Badge bg="success-subtle" text="success" className="border border-success-subtle px-2 py-1 fw-bold">
                                                        <FaCheck className="me-1" size={10} /> {assoc}
                                                    </Badge>
                                                ) : (
                                                    <Badge bg="danger-subtle" text="danger" className="border border-danger-subtle px-2 py-1 fw-normal">
                                                        <FaTimes className="me-1" size={10} /> Não associada
                                                    </Badge>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <Button variant="outline-danger" size="sm" className="py-0 px-2" onClick={() => handleEditar(item)}>
                                                    <FaEdit size={12} />
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                                {!loading && dadosFiltrados.length === 0 && (
                                    <tr><td colSpan="4" className="text-center py-4 text-muted">Nenhum registro para o filtro selecionado.</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div className="bg-white p-3 rounded-3 shadow-sm border">
                        <Button variant="link" size="sm" onClick={() => setView('lista')} className="mb-3 p-0 text-decoration-none fw-bold text-danger d-inline-flex align-items-center gap-1">
                            <FaArrowLeft /> VOLTAR PARA LISTA
                        </Button>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <Form.Label className="small fw-bold text-secondary mb-1">Roteamento</Form.Label>
                                <Form.Control size="sm" plaintext readOnly className="fw-bold border-bottom px-2 bg-light rounded-1" value={form.roteamento} />
                            </div>
                            <div className="col-md-6">
                                <Form.Label className="small fw-bold text-secondary mb-1">Bandeira do Arquivo</Form.Label>
                                <Form.Control size="sm" plaintext readOnly className="fw-bold border-bottom px-2 bg-light rounded-1" value={form.bandeiraimp} />
                            </div>
                            <div className="col-md-12">
                                <Form.Label className="small fw-bold text-danger mb-1">Associar com a Bandeira do Sistema:</Form.Label>
                                <Form.Select 
                                    size="sm" 
                                    className="border-danger"
                                    value={form.bandflor} 
                                    onChange={e => setForm({...form, bandflor: e.target.value})}
                                >
                                    <option value="">Selecione a bandeira correspondente...</option>
                                    {lookups.bandeirasSugeridas.map((b, idx) => (
                                        <option key={idx} value={b.bandeira || b}>{b.bandeira || b}</option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="bg-white border-top-0 py-2">
                <Button variant="secondary" size="sm" className="fw-semibold" onClick={onHide}>FECHAR</Button>
                {view === 'formulario' && (
                    <Button variant="primary" size="sm" className="fw-bold px-3" onClick={handleSalvar} disabled={loading}>
                        {loading ? 'SALVANDO...' : 'CONFIRMAR ASSOCIAÇÃO'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}